import React from 'react'

export default function Services() {
    return (
        <section className="feature-section ptb-100">
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col-lg-4">
                    <div className="feature-content">
                        <span>Services</span>
                        <h3>You can help the poor through us</h3>
                        <p>
                        Child Hope intends to change this nation by helping one child at a time. But we can’t do it without you. Whether you give, volunteer or foot a sponsorship, your generosity means the world in the life of a child.
                        </p>
                        <a href="#" className="optional-btn">
                            Read More
                            <i className="flaticon-right"></i>
                        </a>
                    </div>
                </div>
                <div className="col-lg-8">
                    <div className="feature-slider owl-carousel owl-theme owl-loaded owl-drag">
                        <div className="owl-stage-outer">
                            <div className="owl-stage"
                                style={{transform:'translate3d(-1106px, 0px, 0px)', transition: 'all 1s ease 0s', width: '2767px'}}>
                                <div className="owl-item" style={{width: '246.667px', marginRight: '30px'}}>
                                    <div className="feature-card">
                                        <div className="icon">
                                            <img src="assets/img/icons/2.png" alt="Quick Fundraiser"/>
                                            <img src="assets/img/icons/white-2.png" alt="Quick Fundraiser"/>
                                        </div>
                                        <h3>Quick Fundraiser</h3>
                                        <p>
                                        Whether it’s an athletic challenge like a marathon, a special occasion, or your own event, help raise money and support for the Child Care children who need it most.
                                        </p>
                                        <br/>
                                        <a href="#" className="feature-btn">
                                            Give now+
                                        </a>
                                    </div>
                                </div>
                                <div className="owl-item" style={{width: '246.667px', marginRight: '30px'}}>
                                    <div className="feature-card">
                                        <div className="icon">
                                            <img src="assets/img/icons/3.png" alt="Give Donations"/>
                                            <img src="assets/img/icons/white-3.png" alt="Give Donations"/>
                                        </div>
                                        <h3>Give Donations</h3>
                                        <p>
                                        Another way of supporting is to give donations. Everything and anything is very much appreciated. To support us this way, contact us here.
                                        </p>
                                         <br/>
                                         <br/>
                                        <a href="#" className="feature-btn">
                                            Give now+
                                        </a>
                                    </div>
                                </div>
                                <div className="owl-item" style={{width: '246.667px', marginRight: '30px'}}>
                                    <div className="feature-card">
                                        <div className="icon">
                                            <img src="assets/img/icons/4.png" alt="Join as Member"/>
                                            <img src="assets/img/icons/white-4.png" alt="Join as Member"/>
                                        </div>
                                        <h3>Join as Member</h3>
                                        <p>
                                        Alternatively, join us and become a member of the Child Care team! </p>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <a href="#" className="feature-btn">
                                            Join now +
                                        </a>
                                    </div>
                                </div>
                                <div className="owl-item" style={{width: '246.667px', marginRight: '30px'}}>
                                    <div className="feature-card">
                                        <div className="icon">
                                            <img src="assets/img/icons/1.png" alt="Become Volunteer"/>
                                            <img src="assets/img/icons/white-1.png" alt="Become Volunteer"/>
                                        </div>
                                        <h3>Advocate for the children.</h3>
                                        <p>
                                        Use your voice — and your social networks — to take action on critical issues and urge government leaders to make children a top priority. Children are our future.
                                        </p>
                                        <br/>
                                        <a href="#" className="feature-btn">
                                            Give now +
                                        </a>
                                    </div>
                                </div>
                                <div className="owl-item" style={{width: '246.667px', marginRight: '30px'}}>
                                    <div className="feature-card">
                                        <div className="icon">
                                            <img src="assets/img/icons/2.png" alt="Quick Fundraiser"/>
                                            <img src="assets/img/icons/white-2.png" alt="Quick Fundraiser"/>
                                        </div>
                                        <h3>Quick Fundraiser</h3>
                                        <p>
                                        Whether it’s an athletic challenge like a marathon, a special occasion, or your own event, help raise money and support for the Child Care children who need it most.
                                        </p>
                                        <br/>
                                        <a href="#" className="feature-btn">
                                            Give now+
                                        </a>
                                    </div>
                                </div>
                                <div className="owl-item" style={{width: '246.667px', marginRight: '30px'}}>
                                    <div className="feature-card">
                                        <div className="icon">
                                            <img src="assets/img/icons/3.png" alt="Give Donations"/>
                                            <img src="assets/img/icons/white-3.png" alt="Give Donations"/>
                                        </div>
                                        <h3>Give Donations</h3>
                                        <p>
                                        Another way of supporting is to give donations. Everything and anything is very much appreciated. To support us this way, contact us here.
                                        </p>
                                         <br/>
                                         <br/>
                                        <a href="#" className="feature-btn">
                                            Give now+
                                        </a>
                                    </div>
                                </div>
                                <div className="owl-item" style={{width: '246.667px', marginRight: '30px'}}>
                                    <div className="feature-card">
                                        <div className="icon">
                                            <img src="assets/img/icons/4.png" alt="Join as Member"/>
                                            <img src="assets/img/icons/white-4.png" alt="Join as Member"/>
                                        </div>
                                        <h3>Join as Member</h3>
                                        <p>
                                        Alternatively, join us and become a member of the Child Care team! </p>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <a href="#" className="feature-btn">
                                            Join now +
                                        </a>
                                    </div>
                                </div>
                                <div className="owl-item" style={{width: '246.667px', marginRight: '30px'}}>
                                    <div className="feature-card">
                                        <div className="icon">
                                            <img src="assets/img/icons/1.png" alt="Become Volunteer"/>
                                            <img src="assets/img/icons/white-1.png" alt="Become Volunteer"/>
                                        </div>
                                        <h3>Become Volunteer</h3>
                                        <p>
                                        There are many ways you can volunteer to support our mission. From one-time opportunities to ongoing partnerships, your involvement on behalf of children can start a ripple of change — changing the lives of children and the future we all share.  </p>
                                        <a href="#" className="feature-btn">
                                            Apply now+
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="owl-nav disabled">
                            <button type="button" role="presentation" className="owl-prev">
                                <span aria-label="Previous">
                                    </span></button> <button type="button" role="presentation" className="owl-next">
                                        <span aria-label="Next"></span>
                            </button>
                        </div>
                         {/* <div className="owl-dots">
                                <button role="button" className="owl-dot">
                                    <span></span>
                                </button>
                                <button role="button" className="owl-dot">
                                    <span></span>
                                </button>
                            </div>  */}
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}
